import { PersonDTO, ReferencedPersonDTO } from '../../api/core';
import { mapPersonNameDtosToReferencedPersonNameDtos } from './PersonNameDtoToReferencedPersonNameDto';

export const mapPersonDtoToReferencedPersonDto = (dto: PersonDTO): ReferencedPersonDTO => {
  if(dto.id === undefined) {
    return null;
  }
  return {
    id: dto.id,
    personNames: mapPersonNameDtosToReferencedPersonNameDtos(dto.personNames),
    externalIds: dto.externalIds,
  };
};

export const mapPersonDtosToReferencedPersonDtos = (dtos: PersonDTO[]): ReferencedPersonDTO[] =>
  dtos
    .map(mapPersonDtoToReferencedPersonDto)
    .filter(p => p !== null);